/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim
*https://cors-anywhere.herokuapp.com/http://reacttest.winnercloudstudio.com/api/mewahapicode.php?mode=
*http://reacttest.winnercloudstudio.com/api/mewahapicode.php?mode=
=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.jsx";
import Report from "views/Report.jsx";
import Profile from "views/examples/Profile.jsx";
import Stock from "views/examples/Stock.jsx";
import Register from "views/examples/Register.jsx";
import Login from "views/examples/Login.jsx";
import Tables from "views/examples/Tables.jsx";
import Sales from "views/examples/Sales.jsx";
import AddNewSales from "views/examples/AddNewSales.jsx";
import ClaimWarranty from "views/examples/ClaimWarranty.jsx";
import AddNewStock from "views/examples/AddNewStock.jsx";
import Forget from "views/examples/Forgetpassword.jsx";
import Commission from "views/examples/Commission.jsx";
import SaleReport from "views/examples/Report.jsx";
import PaymentSummary from "views/examples/PaymentSummary.jsx";
import TransferStock from "views/examples/Transferstock.jsx";
import MembershipCheck from "views/member/MembershipCheck.jsx";
import Membership from "views/member/Membership.jsx";
import MembershipReport from "views/member/MembershipReport.jsx";
import BlastEmail from "views/member/BlastEmail.jsx";
import BlastWhatsapp from "views/member/BlastWhatsapp.jsx";
import BirthdayMarketing from "views/member/BirthdayMarketing.jsx";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-blue",
    component: Dashboard,
    layout: "/admin"
  },
  // {
  //   path: "/report",
  //   name: "Report",
  //   icon: "ni ni-tv-2 text-blue",
  //   component: Report,
  //   layout: "/admin"
  // },
  {
    path: "/stock",
    name: "Stock",
    icon: "ni ni-collection text-blue",
    component: Stock,
    layout: "/admin"
  },
  {
    path: "/Transferstock",
    name: "Transfer Phone",
    icon: "ni ni-collection text-blue",
    component: TransferStock,
    layout: "/admin"
  },
  {
    path: "/sales",
    name: "Sales",
    icon: "ni ni-money-coins text-blue",
    component: Sales,
    layout: "/admin"
  },
  {
    path: "/report",
    name: "Report",
    icon: "ni ni-money-coins text-blue",
    component: SaleReport,
    layout: "/admin"
  },
  {
    path: "/PaymentSummary",
      name: "Payment Summary",
      icon: "ni ni-folder-17 text-blue",
      component: PaymentSummary,
      layout: "/admin"
    },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth"
  },
  {
    path: "/addnewsales",
    name: "Add New Sales",
    sidebarName: "New Sales",
    icon: "ni ni-folder-17 text-blue",
    component: AddNewSales,
    layout: "/admin"
  },
  {
    path: "/addnewstock",
    name: "Add New Stock",
    sidebarName: "New Stock",
    icon: "ni ni-settings-gear-65 text-blue",
    component: AddNewStock,
    layout: "/admin"
  },
  {
    path: "/claimwarranty",
    name: "Claim Warranty",
    icon: "ni ni-world text-blue",
    component: ClaimWarranty,
    layout: "/admin"
  },
  {
    path: "/comission",
    name: "Commission",
    icon: "ni ni-credit-card text-blue",
    component: Commission,
    layout: "/admin"
  },
  {
    path: "/membershipcheck",
    group: "Membership",
    name: "Membership Check",
    sidebarName: "Check Member",
    icon: "ni ni-badge text-blue",
    component: MembershipCheck,
    layout: "/admin"
  },
  // sidebarName: shorter label for the sidebar (page title keeps name). group: shown inside a collapsible sidebar dropdown. ownerOnly: only visible to the MingZe account (see Sidebar.jsx)
  {
    path: "/membership",
    group: "Membership",
    name: "Membership",
    sidebarName: "Members",
    icon: "ni ni-single-02 text-blue",
    component: Membership,
    layout: "/admin",
    ownerOnly: true
  },
  {
    path: "/membershipreport",
    group: "Membership",
    name: "Membership Report",
    sidebarName: "Member Report",
    icon: "ni ni-chart-bar-32 text-blue",
    component: MembershipReport,
    layout: "/admin",
    ownerOnly: true
  },
  {
    path: "/blastemail",
    group: "Marketing",
    name: "Blast Email",
    icon: "ni ni-email-83 text-blue",
    component: BlastEmail,
    layout: "/admin",
    ownerOnly: true
  },
  {
    path: "/blastwhatsapp",
    group: "Marketing",
    name: "Blast WhatsApp",
    icon: "ni ni-send text-blue",
    component: BlastWhatsapp,
    layout: "/admin",
    ownerOnly: true
  },
  {
    path: "/birthdaymarketing",
    group: "Marketing",
    name: "Birthday Marketing",
    sidebarName: "Birthday",
    icon: "ni ni-satisfied text-blue",
    component: BirthdayMarketing,
    layout: "/admin",
    ownerOnly: true
  },
];
export default routes;
